import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IndexCard } from '../../../auth/store/models';

@Component({
    selector: 'app-statistik-kunder-options',
    templateUrl: './statistik-kunder-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikKunderOptionsComponent {
    @Input() koncerns: (string | undefined)[] = [];
    @Input() medarbejdere: IndexCard[];
    @Input() laCards: IndexCard[];
    @Input() kaCards: IndexCard[];
    @Input() periode: string;
    @Input() selectedMedarbejder: number;
    @Output() periodeChange = new EventEmitter<string>();

    @Output() selectMedarbejderID = new EventEmitter<number>();
    @Output() selectKundeAnsvarlig = new EventEmitter<number>();
    @Output() selectLedelseAnsvarlig = new EventEmitter<number>();
    @Output() selectKoncern = new EventEmitter<string>();
    @Output() selectDecimal = new EventEmitter<number>();
    @Output() selectHourFormat = new EventEmitter<string>();
    @Output() selectDeciminuts = new EventEmitter<boolean>();
    @Output() selectRemoveAfsluttet = new EventEmitter<boolean>();
    @Output() exportExcel = new EventEmitter();

    selectedKundeansvarlige: number;
    selectedKundeansvarligeName: string;

    selectedLedelseansvarlige: number;
    selectedLedelseansvarligeName: string;

    selectedKoncern?: string;

    selectedDecimal = 2;
    decimals = [0, 1, 2];

    selectedHourFormat = 'Timer';
    hourFormats = [
        {text: 'Timer', value: 'Timer'},
        {text: 'Timer i KR', value: 'KR'},
        {text: 'Timer i TKR', value: 'TKR'}
    ];

    inDeciminutes: boolean;
    removeAfsluttet: boolean;

    get years(): number[] {
        const firstYear = 2010;
        let lastYear = new Date().getFullYear() + 1;
        const periodArray: number[] = [];
        while (lastYear >= firstYear) {
            periodArray.push(lastYear--);
        }
        return periodArray;
    }

    onPeriodeChange(periode: string, isValidDate: boolean) {
        if (!isValidDate || periode === '') { return; }
        this.periodeChange.emit(periode);
    }

    onSelectMedarbejder(medID: number) {
        this.selectMedarbejderID.emit(medID);
    }

    onSelectKundeansvarlige(ka: number, FN: string, LN: string) {
        this.selectedKundeansvarlige = ka;
        this.selectKundeAnsvarlig.emit(ka);
        this.selectedKundeansvarligeName = ka !== null ? FN + ' ' + LN : null;

    }

    onSelectLedelseansvarlige(la: number, FN: string, LN: string) {
        this.selectedLedelseansvarlige = la;
        this.selectLedelseAnsvarlig.emit(la);
        this.selectedLedelseansvarligeName = la !== null ? FN + ' ' + LN : null;
    }

    onSelectKoncern(koncernNavn?: string) {
        this.selectedKoncern = koncernNavn;
        this.selectKoncern.emit(koncernNavn);
    }

    onSelectHourFormat(format: string) {
        this.selectedHourFormat = format;
        this.selectHourFormat.emit(format);
    }

    onSelectDecimal(decimals: number | null) {
        this.selectedDecimal = decimals;
        this.selectDecimal.emit(decimals);
    }

    onSelectDeciminuts(deciminuts: boolean) {
        this.selectDeciminuts.emit(deciminuts);
    }

    onRemoveAfsluttet(closing: boolean) {
        this.selectRemoveAfsluttet.emit(closing);
    }

    onExportExcel() {
        this.exportExcel.emit();
    }

    getSelectedMedarbejderText(selectedMedarbejder: number) {
        if (this.selectedMedarbejder && this.medarbejdere) {
            const userCard = this.medarbejdere.find(u => u.cardId === selectedMedarbejder);
            return `${userCard?.fornavn} ${userCard?.efternavn}`;
        }
        return 'Alle';
    }
}

